import { useSelector } from "react-redux";
import { Truck } from "lucide-react";
import ArrowSorting from "../../../../components/common/ArrowSorting";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import { getVehicleReadingStatus } from "../../helpers/getComplaintStatus";
import { formatTime } from "../../../../functions/dateTime/getTimeString";

export const VehicleReadingTable = ({
  tableHeight,
  columns,
  showStatus,
  setOpenDialog,
}) => {
  const vehiclesData = useSelector((state) => state.data.data);
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden mt-2">
      <div className={`whitespace-nowrap ${tableHeight} overflow-auto`}>
        <table className="w-full border border-b-0">
          {/* Header */}
          <thead className="bg-[#f4f6fc] text-blue-1 uppercase text-[14px] max-lg:text-[11px] sticky top-0 2xs:max-md:top-0 z-99">
            <tr>
              {columns.map((c) => (
                <th key={c.title} className="text-left px-4 py-3">
                  <span className="flex items-center">
                    {c.title}{" "}
                    {c.sortArrow && vehiclesData.length > 1 && (
                      <ArrowSorting
                        sortBy={c.sortBy}
                        address={c.address}
                        arrowColor="#3a4faa"
                      />
                    )}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          {/* Body */}
          <tbody className="text-[14px] max-lg:text-xs">
            {vehiclesData.length > 0 ? (
              vehiclesData.map((v) => (
                <tr
                  key={v.id}
                  className="border-t hover:bg-gray-50 text-gray-800 [&_td]:p-3"
                >
                  <td>{formatDate(v.logDate)}</td>
                  <td>
                    <p className="inline-flex px-2 bg-blue-100 border-1 border-blue-200 rounded-md items-center gap-1">
                      <Truck className="text-blue-50" size={15} />
                      {v.vehicleNumber}
                    </p>
                  </td>
                  <td>{v.createdBy.fullName}</td>
                  <td>{formatTime(v.morningReadingAt)}</td>
                  <td>{v.morningReading}</td>
                  <td>{formatTime(v.eveningReadingAt)}</td>
                  <td>{v.eveningReading}</td>
                  <td>{v.distanceKm} km</td>
                  {showStatus && (
                    <td
                      className={`status-data ${
                        getVehicleReadingStatus(v.status).textColor
                      }`}
                    >
                      {getVehicleReadingStatus(v.status).status}
                    </td>
                  )}
                  <td>
                    <button
                      className="bg-blue-2 text-dark-blue rounded-full text-center px-4 py-[2px] hover:bg-dark-blue hover:text-white transition"
                      onClick={() => setOpenDialog({ openView: true, data: v })}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center py-6 text-gray-500"
                >
                  No match the current filter.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
